import React, { useEffect, useState } from "react";
import Modal from "../common/modal";
import Button from "../common/button";

const ApplicationImageRejectModal = ({
  isOpen,
  onClose,
  image,
  onConfirm,
  isLoading = false,
}) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (isOpen) {
      setReason("");
      setError("");
    }
  }, [isOpen, image]);

  if (!isOpen) return null;

  const title = image?.title || image?.name || "Application Image";

  const handleConfirm = () => {
    const trimmed = reason.trim();
    if (!trimmed) {
      setError("Please provide a reason for rejection.");
      return;
    }
    setError("");
    onConfirm(trimmed);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Reject Application Image">
      <div style={{ padding: "4px 0 8px" }}>
        <p style={{ margin: "0 0 16px", color: "#555", fontSize: "14px" }}>
          You are rejecting <strong style={{ color: "#333" }}>{title}</strong>.
          Please explain why.
        </p>

        <label
          htmlFor="reject-reason"
          style={{
            display: "block",
            marginBottom: "8px",
            fontSize: "13px",
            fontWeight: 600,
            color: "#555",
          }}
        >
          Rejection reason <span style={{ color: "#d11a2a" }}>*</span>
        </label>
        <textarea
          id="reject-reason"
          rows={4}
          value={reason}
          onChange={(e) => {
            setReason(e.target.value);
            if (error) setError("");
          }}
          placeholder="Describe why this application image is being rejected..."
          disabled={isLoading}
          style={{
            width: "100%",
            padding: "12px",
            borderRadius: "10px",
            border: error ? "1px solid #d11a2a" : "1px solid #ddd",
            fontSize: "14px",
            fontFamily: "inherit",
            resize: "vertical",
            boxSizing: "border-box",
          }}
        />
        {error && (
          <p style={{ margin: "8px 0 0", color: "#d11a2a", fontSize: "12px" }}>
            {error}
          </p>
        )}
      </div>

      <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
        <Button onClick={onClose} className="CancelButton" disabled={isLoading}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          className="CcommonButton"
          disabled={isLoading}
        >
          {isLoading ? "Rejecting..." : "Reject"}
        </Button>
      </div>
    </Modal>
  );
};

export default ApplicationImageRejectModal;
